export default {
  actionButton: 'Оставить заявку на звонок',
  submitButton: 'Регистрация',
  themeContentTitle: 'Жизнь среди искусства',
  themeContentDesc: 'острове Saadiyat',
  themeLaunchDesc:
    'Квартиры с одной, двумя и тремя спальнями в Культурном районе острова Саадият',
  welcomeText:
    'Добро пожаловать в Arthouse — жилой комплекс в районе Саадият Грув! Каждая квартира здесь говорит о креативности и комфорте. Откройте для себя уникальное жилое пространство, подобное частному клубу с особой атмосферой энергии.',
  epicHeading: 'Жизнь в роскоши в самом центре культурной жизни',
  epicContentp1:
    'Arthouse - новое сокровище в Культурном районе Saadiyat. Комплекс расположен недалеко от известных достопримечательностей, таких как Лувр Абу-Даби, Музей естественной истории, Гугенхайм Абу-Даби, Национальный музей имени шейха Заида, teamLab Phenomena и Центр исполнительских искусств Абу-Даби.',
  epicContentp2:
    'Наш комплекс предлагает своим обитателям идеальные условия для интеграции, процветания и вдохновения.',
  exploreButton: 'Ознакомьтесь с районом',
  epicLaunchHeading: 'Жизнь в роскоши в самом центре культурной жизни',
  epicLaunchContent:
    'The Arthouse - новый престижный жилой комплекс в Культурном районе острова Саадият, расположенный вблизи Лувра Абу-Даби, Музея естественной истории, Музея Гуггенхайма в Абу-Даби, Национального музея шейха Заида, teamLab Phenomena и Центра исполнительских искусств Абу-Даби. Жители комплекса имеют прекрасную возможность общаться друг с другом, черпая вдохновение от жизни в этом месте и наслаждаясь ей',
  productHeading:
    'Роскошные квартиры с одной, двумя и тремя спальнями, где продумана каждая деталь',
  productContent:
    'Каждая квартира является результатом тщательной работы дизайнеров — здесь пробуждается дух творчества и стремление к взаимному общению. The Arthouse — это жизнь среди искусства, где каждая деталь продумана, начиная от элегантных интерьеров и заканчивая общими пространствами.',
  productButton: 'Ознакомьтесь с планировками квартир',
  experienceHeading:
    'Уникальная энергия жилого комплекса, созданного по подобию частного клуба',
  experienceContent:
    'The Arthouse — это эксклюзивное сообщество, которое вдохновляет и восхищает. Наслаждайтесь моментами тишины и спокойствия среди зелени и отдыхайте в лаунже на крыше возле бассейна. Благодаря сервисам мирового уровня ваша жизнь достигнет нового уровня, а ваше воображение займут новые увлекательные планы. ',
  contactHeading: 'Закрепите за собой свою недвижимость прямо сейчас',
  contactContent:
    'Мы рады, что вы проявили интерес к жилому комплексу The Arthouse. Зарегистрируйтесь, чтобы связаться с нашими менеджерами по продажам, получить дополнительную информацию о комплексе The Arthouse в Культурном районе на острове Саадият и узнать, как можно купить квартиру своей мечты.',
  noVideoTagSupport: 'Your browser does not support the video tag.',
  formHeading: 'Получайте наши новости первыми',
  formDesc:
    'Зарегистрируйтесь, чтобы поговорить с нашим менеджером продаж об Arthouse и уникальном Культурном районе Saadiyat, а также узнать, как приобрести недвижимость вашей мечты. ',
  firstName: 'Имя',
  lastName: 'Фамилия',
  email: 'Адрес электронной почты',
  phoneNumber: 'Номер телефона',
  reasonToBuy: 'Причины покупки',
  nationality: 'Гражданство',
  residencyStatus: 'Статус проживания',
  residencyStatusOptionResident: 'резидента',
  residencyStatusOptionNonResident: 'Нерезидент',
  reasonBuyOptionInvestor: 'Инвестировать',
  reasonBuyOptionHomeOwner: 'Жить',
  recieveUpdates:
    'Да, я хочу получать предложения покупки элитной недвижимости, индивидуальные консультации и информацию о тенденциях рынка.',
  consentLabel: 'Я даю согласие на',
  privacyPolicy: 'Политика конфиденциальности',
  termsAndConditions: 'Условия использования',
  consentLabelEnd: 'Из Aldar',
  footerContactTitle: 'Свяжитесь с нами:',
  launchFooterContactTitle: 'Свяжитесь с нами:',
  footerContactCallText: 'ЗВАТЬ',
  footerContactCallNumber: '800 ALDAR',
  footerContactNumber: '+971 2 810 6400',
  footerContactWebsite: 'Aldar.com',
  developedBy: 'Застройщик: Aldar Properties',
  successHeading: 'Благодарим вас за регистрацию',
  successContent:
    'Наши менеджера по продажам будут рады пообщаться с вами. Просим вас следить за своей почтой, чтобы не пропустить эксклюзивную информацию. Хотите знать, что еще может предложить вам компания Aldar? Откройте для себя другие объекты жилой недвижимости мирового класса, расположенные в самом центре Культурного района Абу-Даби.',
  metaTitle: ' Arthouse: жизнь как в галерее',
  metaDescription:
    'Ознакомьтесь с новейшим проектом Aldar: жилой комплекс, созданный по подобию частного клуба в самом центре культурной жизни острова Saadiyat в Абу-Даби.',
  launchWelcomeText:
    'Добро пожаловать в Arthouse, где каждая квартира олицетворяет собой комфорт и творчество. Загляните в особенное жилое пространство, спроектированное в формате частного клуба, наполненного энергией сообщества единомышленников.',
  serviceHeading: 'Инвестируйте в жилье уже сегодня',
  serviceContent:
    'Независимо от того, ищете ли вы роскошные апартаменты на острове Саадият или же хотите добавить нечто необычное в свой портфель недвижимости — жилой комплекс The Arthouse станет для вас исключительным выбором.',
  serviceTabOne: 'Сервисы мирового уровня',
  serviceTabTwo: 'Потенциал для прироста капитала',
  serviceTabThree: 'Расположение на острове, пользующееся повышенным спросом',
  experienceTab1main: 'Большой зал',
  experienceTab1sub:
    'Просторное, художественное лобби с пышной тропической элегантностью ',
  experienceTab2main: 'Арт-студия',
  experienceTab2sub:
    'Творческий центр и вдохновляющее рабочее пространство с художественной галереей',
  experienceTab3main: 'Маджлис для резидентов',
  experienceTab3sub: 'Эксклюзивный современный арабский частный лаунж',
  experienceTab4main: 'Небесный сад',
  experienceTab4sub: 'Оазис на крыше с захватывающими видами',
  experienceTab5main: 'Артхаусный кинотеатр',
  experienceTab5sub: 'Роскошные показы независимых фильмов для ценителей',
  experienceTab6main: 'Развлекательный лаунж',
  experienceTab6sub: 'Эксклюзивное игровое пространство для отдыха',
  experienceTab7main: 'Гурмэ-клуб',
  experienceTab7sub: 'Изысканная социальная кухня для незабываемых встреч',
  experienceTab8main: 'Фитнес студия',
  experienceTab8sub: 'Современное фитнес-убежище для элитного здоровья',
  experienceTab9main: 'Студия Core',
  experienceTab9sub: 'Спокойное пространство для восстановления души и тела',
  experienceTab10main: 'Теннисный корт',
  experienceTab10sub: 'Безупречный корт для оттачивания спортивного мастерства',
  experienceTab11main: 'Тропический ландшафтный сад',
  experienceTab11sub: 'Тщательно ухоженная природная красота для прогулок',
  experienceTab12main: 'Бассейн на крыше',
  experienceTab12sub:
    'Роскошное водное убежище на высоте с потрясающими видами',
  experienceTab13main: 'Детская игровая комната',
  experienceTab13sub:
    'Интерактивное пространство для развития детского творчества',
  experienceTab14main: 'Коворкинг-пространства',
  experienceTab14sub:
    'Где дизайн встречается с продуктивностью и зажигает смелые разговоры',
  contactCommentsPlaceholder: 'У вас есть комментарии или вопросы?',
  successButton: 'Ознакомиться с другими предложениями недвижимости',
};
